import { createSlice } from '@reduxjs/toolkit';

const MachineDetailsDataSlice = createSlice({
    name: 'MachineDetailsData',
    initialState: '',
    reducers: {
        setMachineDetailsData: (state, action) => {
            return action.payload;
        },
        resetMachineDetailsData: (state) => {
            return null;
        },
    },
});

export const { setMachineDetailsData, resetMachineDetailsData } = MachineDetailsDataSlice.actions;
export default MachineDetailsDataSlice.reducer;